import { Avatar, IconButton, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import React from 'react';

import useAuth from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

type ProfileSettingsMenuProps = {
  anchorElUser: null | HTMLElement;
  handleOpenUserMenu: (event: React.MouseEvent<HTMLElement>) => void;
  handleCloseUserMenu: () => void;
};

export default function ProfileSettingsMenu(props: ProfileSettingsMenuProps) {
  const navigate = useNavigate();
  const auth = useAuth();

  // TODO: aim to reproduce that the logout bug is caused by this
  if (!auth.logout) {
    console.log('auth.logout is not defined');
  }

  const userMenuOptions = [
    {
      label: 'Profile',
      onClick: () => navigate('/settings'),
    },
    { label: 'Logout', onClick: () => auth.logout() },
  ];

  return (
    <>
      <Tooltip title='Open settings'>
        <IconButton onClick={props.handleOpenUserMenu} sx={{ p: 0 }}>
          <Avatar
            alt={auth.userQuery.data?.me.firstName}
            src={auth.userQuery.data?.me.profilePictureAttachment?.url}
          />
        </IconButton>
      </Tooltip>
      <Menu
        keepMounted
        sx={{ mt: '45px' }}
        id='menu-appbar'
        anchorEl={props.anchorElUser}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(props.anchorElUser)}
        onClose={props.handleCloseUserMenu}
      >
        {userMenuOptions.map(setting => (
          <MenuItem
            key={setting.label}
            onClick={() => {
              setting.onClick();
              props.handleCloseUserMenu();
            }}
          >
            <Typography textAlign='center'>{setting.label}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
